// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2v-0V","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__9KZxb"};